<p class="mat-body-2">Generate Regents Plan & Prep PDF Reports for {{ count }} students.</p>
<div>
  <button
    class="step-action-button"
    mat-raised-button
    aria-label="Generate Regents Plan & Prep PDF Report"
    [disabled]="!count"
    (click)="openStudentReportModal()"
  >Generate</button>
</div>